export var UpgradeAlertType;
(function (UpgradeAlertType) {
    UpgradeAlertType["FORMS_LIMIT"] = "formsLimit";
    UpgradeAlertType["FIELDS_LIMIT"] = "fieldsLimit";
    UpgradeAlertType["FIELDS_DUPLICATE_LIMIT"] = "fieldsDuplicateLimit";
    UpgradeAlertType["STEPS_LIMIT"] = "stepsLimit";
    UpgradeAlertType["STEPS_DUPLICATE_LIMIT"] = "stepsDuplicateLimit";
    UpgradeAlertType["UPLOAD_BUTTON"] = "uploadButton";
    UpgradeAlertType["DOWNLOAD_REDIRECT"] = "downloadRedirect";
    UpgradeAlertType["EMAILS_LIMIT"] = "emailsLimit";
    UpgradeAlertType["RULES_LIMIT"] = "rulesLimit";
    UpgradeAlertType["FORMS_PAGE_LIMIT"] = "formsPageLimit";
})(UpgradeAlertType || (UpgradeAlertType = {}));
export var BillingPanelReferrer;
(function (BillingPanelReferrer) {
    BillingPanelReferrer["GFPP"] = "GPFF";
    BillingPanelReferrer["MANAGE_FIELDS_LINK"] = "manage_fields";
    BillingPanelReferrer["ADD_FIELD_LINK"] = "add_new_field";
    BillingPanelReferrer["NUMBER_OF_FIELDS_ALERT"] = "number_of_fields_alert";
    BillingPanelReferrer["NUMBER_OF_STEPS_ALERT"] = "number_of_steps_alert";
    BillingPanelReferrer["NUMBER_OF_FORMS_ALERT"] = "number_of_forms_alert";
    BillingPanelReferrer["UPLOAD_FIELD_ALERT"] = "upload_field_alert";
    BillingPanelReferrer["DOWNLOAD_REDIRECT_ALERT"] = "download_redirect_alert";
    BillingPanelReferrer["ADI_UPLOAD_FIELD"] = "adi_upload_field";
    BillingPanelReferrer["ADI_PREMIUM_ALERT_SECTION"] = "adi_premium_alert_section";
    BillingPanelReferrer["DUPLICATE_FIELD_ALERT"] = "duplicate_field_alert";
    BillingPanelReferrer["NUMBER_OF_EMAILS_ALERT"] = "number_emails_alert";
    BillingPanelReferrer["NUMBER_OF_RULES_ALERT"] = "number_rules_alert";
})(BillingPanelReferrer || (BillingPanelReferrer = {}));
//# sourceMappingURL=premium.js.map